import React from 'react';

const Loader = () => {
  // 1. CSS Object (Normal styles ke liye)
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
  };

  const loaderStyle = {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #3498db',
    borderRadius: '50%',
  };

  return (
    <div style={containerStyle}>
      {/* 2. Animation ke liye hume ek chhota sa <style> tag dena padega 
          kyunki inline style={ } me animation support nahi hota */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      
      <div 
        style={{
          ...loaderStyle, 
          animation: 'spin 1s linear infinite' // Inline animation trigger
        }} 
      />
    </div>
  );
};

export default Loader;